import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'
import {
    content,
    dashboard,
    fixtures,
    selfServe,
    stores,
    userProfile,
} from '../Landing/LandingIcons/index'
import { usePageTitle } from '../../actions/app'
import './Landing.style.scss'
import { ACL, Routes } from '../../constants'
import { getDashboards, getSelectedEstateId } from '../../reducers/app'
import { useAppSelector } from '../../reducers'
import { EstateUtils } from '../../utils'

export default function Landing() {
    const hasAccessToSelfServe = useAppSelector(
        (state) => EstateUtils.hasPermission(state, { acls: [ACL.VIEW_SELF_SERVE] }, { ignoreAdmin: true }),
    )
    const estate = useAppSelector(getSelectedEstateId)
    const hasAnyDashboard = useAppSelector(state => getDashboards(state).length > 0)
    const { t } = useTranslation()
    usePageTitle()

    const getCurrentDate = () => {
        const date = new Date()
        const daysOfWeek = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']
        const months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']
        const dayOfWeek = daysOfWeek[date.getDay()]
        const dateOfMonth = date.getDate()
        const month = months[date.getMonth()]
        const year = date.getFullYear()
        let hours = date.getHours()
        let minutes = date.getMinutes()
        const ampm = hours >= 12 ? 'pm' : 'am'
        hours = hours % 12
        hours = hours ? hours : 12
        if (minutes < 10) {
            minutes = `0${minutes}`
        }

        const time = `${hours}:${minutes}${ampm}`
        return `${dayOfWeek} ${dateOfMonth} ${month} ${year}, ${time}`
    }

    const buildRoute = (route) => Routes.buildRoute(route, { estate })

    return (
        <div className="landing-page">
            <div className="landing-top">
                <p>Welcome back</p>
                <div className="date">{getCurrentDate()}</div>
            </div>
            <div className="grid">
                <Link className="grid-item" to={buildRoute(Routes['ESTATE:LIST'])}>
                    <img src={stores} alt="store"></img>
                    <p>{t('Stores')}</p>
                </Link>
                <Link className="grid-item" to={buildRoute(Routes.CONTENT)}>
                    <img src={fixtures} alt="content"></img>
                    <p>{t('Content')}</p>
                </Link>
                <Link className="grid-item" to={buildRoute(Routes['CONTENT:MEDIA'])}>
                    <img src={content} alt="media"></img>
                    <p>{t('media')}</p>
                </Link>
                {hasAccessToSelfServe && (
                    <Link className="grid-item" to={buildRoute(Routes.SELF_SERVE)}>
                        <img src={selfServe} alt="self-serve"></img>
                        <p>{t('self-serve')}</p>
                    </Link>)
                }
                {!hasAccessToSelfServe && (
                    <div className="grid-item not-active">
                        <img src={selfServe} alt="self-serve"></img>
                        <p>{t('self-serve')}</p>
                    </div>)
                }
                {hasAnyDashboard && (
                    <Link className="grid-item" to={buildRoute(Routes.REPORTING_DASHBOARDS)}>
                        <img src={dashboard} alt="reports"></img>
                        <p>{t('reports')}</p>
                    </Link>
                )}
                {!hasAnyDashboard && (
                    <div className="grid-item not-active">
                        <img src={dashboard} alt="reports"></img>
                        <p>{t('reports')}</p>
                    </div>
                )}
                <Link className="grid-item not-active">
                    <img src={userProfile} alt="user profile"></img>
                    <p>User Profile</p>
                </Link>
            </div>
        </div>
    )
}
